"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDDS = exports.isDDS = void 0;
function isDDS(buffer) {
  return buffer.readUInt32LE(0) === 0x20534444;
}
exports.isDDS = isDDS;
function calculateDDS(buffer) {
  return {
    height: buffer.readUInt32LE(12),
    width: buffer.readUInt32LE(16)
  };
}
exports.calculateDDS = calculateDDS;